import { OrderKeyEncoding } from "../position/OrderKey";

export const Positions = new OrderKeyEncoding("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz");
